import UniformPage from "./page";

export default UniformPage;
